import React from "react";
import Slider from "react-slick";
import { breakpoints } from "utils";
import "./styles.scss";
// Slider settings
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
};
export const SliderComponent = ({ children, length }) => {
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", () => {
        setScreenWidth(window.innerWidth);
      });
    };
  }, []);
  return (
    <Slider
      slidesToShow={
        screenWidth > breakpoints.medium.replace("px", "") &&
        !screenWidth < breakpoints.small.replace("px", "")
          ? Number(length) > 3
            ? 3
            : Number(length)
          : screenWidth < breakpoints.small.replace("px", "") &&
            screenWidth > Number(breakpoints.small.replace("px", "")) - 1
          ? 2
          : screenWidth < Number(breakpoints.small.replace("px", "")) + 1
          ? 1
          : 3
      }
      {...settings}
    >
      {children}
    </Slider>
  );
};
